import { BlockRender, FlexibleData, PageRenderTransition } from '@lib/server';

import {
  Accordion,
  AtreemoForm,
  Banner,
  Button,
  CTA,
  Card,
  Carousel,
  Columns,
  ContactForm,
  DesignMyNight,
  Events,
  Facilities,
  GigPig,
  Heading,
  ImageWithCaption,
  Kwizly,
  Map,
  MenuGrid,
  Menus,
  OccasionGrid,
  OfferGrid,
  PlaceSelector,
  PlacesSearch,
  PopUp,
  PostGrid,
  RichText,
  Socials,
  Soda,
  StatsGrid,
  Tabs,
  Times,
  Tonic,
} from '../block';
import { AccentSection } from '../block/accent-section';
import { ActionBar } from '../block/action-bar';
import { FacebookConversionsAPI } from '../block/facebook-conversions-api';
import { LeaveFeedback } from '../block/leave-feedback';
import { LogoCarousel } from '../block/logo-carousel';
import { PricingTable } from '../block/pricing-table';
import { ImageGallery } from '../components/image-gallery';
import { ErrorFallback } from '../layout/error-fallback';
import { Transition } from './transition';

export function PageRender({
  data,
  params,
  transition,
}: {
  data: FlexibleData | undefined;
  params: { domain: string; venue?: string; venuesPage?: string | null };
  transition?: PageRenderTransition;
}) {
  const customRenderers = {
    AccentSection,
    Accordion,
    ActionBar,
    AtreemoForm,
    Banner,
    Button,
    Card,
    Carousel,
    Columns,
    LogoCarousel,
    ContactForm,
    CTA,
    FacebookConversionsAPI,
    DesignMyNight,
    Events,
    Facilities,
    GigPig,
    Heading,
    Image: ImageWithCaption,
    ImageGallery,
    Kwizly,
    LeaveFeedback,
    Map,
    MenuGrid,
    Menus,
    OccasionGrid,
    OfferGrid,
    Offers: OfferGrid,
    PlaceSelector,
    PlacesSearch,
    PopUp,
    PostGrid,
    PricingTable,
    RichText,
    Socials,
    Soda,
    StatsGrid,
    Tabs,
    Times,
    Tonic,
  };

  const noWrapperBlocks = ['PopUp', 'FacebookConversionsAPI'];

  return data?.schema?.map((item) => {
    if (!item?.config) {
      return null;
    }

    if (!customRenderers[item.config as keyof typeof customRenderers]) {
      console.error(`No renderer found for config type: ${item.config}`);
      return null;
    }

    const Block = (
      <BlockRender
        key={item.id}
        errorFallback={ErrorFallback}
        config={item.config}
        fields={data.fields?.[item.id]}
        renderers={customRenderers}
        params={params}
        // pass this through to stagger column animations
        transition={transition && { name: transition?.name }}
      />
    );

    // if the transition is not none, wrap the block in a transition
    if (transition?.name && transition?.name !== 'none' && !noWrapperBlocks.includes(item.config)) {
      return (
        <Transition
          key={item.id}
          waitForInView
          className={transition?.classNames}
          transitionDelay={transition?.delay}
          transitionName={transition?.name}
        >
          {Block}
        </Transition>
      );
    }

    return Block;
  });
}
